// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3oY8h","productName":"Table_productName__1QWe2"};